import React from "react";
import { Button } from "@life-line-lab/components-react";
import { useTranslation } from "react-i18next";

import "./confirm-status.scss";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";

interface ConfirmStatusProps {
  status?: string;
  title?: string;
  subtitle?: string;
  content?: string;
  btnPrm: any;
  btnSec?: any;
}

const handleSetStatusIcon = (status) => {
  switch (status) {
    case "SUCCESS":
      return <CheckCircleOutlined style={{ fontSize: "3rem", color: "hsl(97, 79%, 40%)" }} />;
    case "FAILED":
      return <CloseCircleOutlined style={{ fontSize: "3rem", color: "hsl(0, 64%, 40%)" }} />;
    default:
      return <CheckCircleOutlined style={{ fontSize: "3rem", color: "hsl(97, 79%, 40%)" }} />;
  }
};

const ConfirmStatus: React.FC<ConfirmStatusProps> = (props) => {
  const { status = "SUCCESS", title, subtitle, content, btnPrm, btnSec } = props || {};
  const { btnPrmText, btnPrmFunc } = btnPrm || {};
  const { btnSecText, btnSecFunc } = btnSec || {};

  const statusIcon = handleSetStatusIcon(status);

  const { t } = useTranslation();

  return (
    <div className="confirm-container">
      <div className="confirm-header">
        <div className="confirm-status">{statusIcon}</div>
        <div className="confirm-title">{title ?? t("txt.successUpdate")}</div>
        <div className="confirm-subtitle">{subtitle ?? null}</div>
      </div>
      <div className="confirm-content">{content ?? null}</div>{" "}
      <div className="confirm-btn-container">
        <Button type="primary" label={btnPrmText} onClick={() => btnPrmFunc()} />
        {btnSec && <Button type="secondary" label={btnSecText} onClick={() => btnSecFunc()} />}
      </div>
    </div>
  );
};

export default ConfirmStatus;
